
import { defineComponent } from 'vue'
import ServicesHeader from '../components-services/ServicesHeader.vue'
import LoginDialog from '@/components/dialogs/LoginDialog.vue'
import SignUpDialog from '@/components/dialogs/SignUpDialog.vue'
import { trackLeadLink } from '@/utils/metaPixel'

export default defineComponent({
  name: 'HeroMTShop',
  components: {
    ServicesHeader,
    LoginDialog,
    SignUpDialog,
  },
  data() {
    return {
      showLoginDialog: false,
      showRegDialog: false,
      logos: [
        { alt: 'MT' },
        {
          alt: 'Google',
          label: 'Google',
        },
        {
          alt: 'Facebook',
          label: 'Facebook',
        },
      ],
    }
  },
  methods: {
    onClickLogin() {
      this.showLoginDialog = !this.showLoginDialog
    },
    onClickReg() {
      this.showRegDialog = !this.showRegDialog
    },
    onLeadClick(event: MouseEvent, url: string, contentName: string) {
      trackLeadLink(event, url, {
        contentName,
        contentCategory: 'mt_shop_lead_button',
      })
    },
  },
  computed: {
    repeatedLogos(): Array<{ alt: string; label?: string }> {
      return [
        ...this.logos,
        ...this.logos,
        ...this.logos,
        ...this.logos,
        ...this.logos,
      ] // just duplicate once
    },
  },
})
